import * as core from '../../../../../../../core'

import { query } from './asset-organization-table-details.query'

export const RESOURCE = {
  payload: {
    alias: 'asset.organization.table.details',
    description:
      'Slideout that shows an expandable breakdown of assets per organization',
    name: 'Asset Organization Table Details',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
